<template>
    <div class="edit-room">
        <div class="collapse-room">
            <el-collapse accordion>
                <el-collapse-item title="模型地址">
                    <div class="base-form-div">
                        <el-form size="mini" :rules="rules" :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                            <el-form-item label="模型URL:" prop="url">
                                <el-input v-model="ruleForm.url"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-button class="base-button" size="mini" type="primary" @click="addTilesetLayer">添加模型</el-button>
                    </div>

                </el-collapse-item>
                <el-collapse-item title="模型位置">
                    <div class="base-form-div list-div-line">
                        <el-form size="mini" :rules="rules" :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                            <el-form-item label="经度:" prop="x">
                                <el-input v-model="ruleForm.x"></el-input>
                            </el-form-item>
                            <el-form-item label="纬度:" prop="y">
                                <el-input v-model="ruleForm.y"></el-input>
                            </el-form-item>
                            <el-form-item label="高度:" prop="z">
                                <el-input v-model="ruleForm.z"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-button class="base-button" size="mini" type="primary" @click="updatePos">确定修改</el-button>
                        <!-- <el-button class="base-button" size="mini" type="primary" @click="clampToGround">自动贴地</el-button> -->
                    </div>
                </el-collapse-item>
                <el-collapse-item title="模型偏移">
                    <div class="base-form-div list-div-line">
                        <el-form size="mini" :rules="rules" :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                            <el-form-item label="X方向:" prop="offset_x">
                                <el-input v-model="ruleForm.offset_x"></el-input>
                            </el-form-item>
                            <el-form-item label="Y方向:" prop="offset_y">
                                <el-input v-model="ruleForm.offset_y"></el-input>
                            </el-form-item>
                            <el-form-item label="Z方向:" prop="offset_z">
                                <el-input v-model="ruleForm.offset_z"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-button class="base-button" size="mini" type="primary" @click="updateOffset">确定修改</el-button>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="模型方向">
                    <div class="base-form-div list-div-line-m">
                        <el-form size="mini" :rules="rules" :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                            <el-form-item label="变换坐标轴" prop="axis">
                                <el-select @change="axisChange" v-model="ruleForm.axis">
                                    <el-option v-for="(item) in axisAll" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="绕X轴旋转:" prop="rotationX">
                                <el-input-number :step="0.1" v-model="ruleForm.rotationX" controls-position="right"
                                    @change="rotationChange"></el-input-number>
                            </el-form-item>
                            <el-form-item label="绕Y轴旋转:" prop="rotationY">
                                <el-input-number :step="0.1" v-model="ruleForm.rotationY" controls-position="right"
                                    @change="rotationChange"></el-input-number>
                            </el-form-item>
                            <el-form-item label="绕Z轴旋转:" prop="rotationZ">
                                <el-input-number :step="0.1" v-model="ruleForm.rotationZ" controls-position="right"
                                    @change="rotationChange"></el-input-number>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="模型属性">
                    <div class="base-form-div list-div-line-m">
                        <el-form label-width="64px" label-position="right" size="mini" :rules="rules" :model="ruleForm"
                            ref="ruleForm" class="demo-ruleForm">
                            <el-form-item label="缩放比例:" prop="scale">
                                <el-input-number :step="0.1" v-model="ruleForm.scale" controls-position="right"
                                    @change="scaleChange"></el-input-number>
                            </el-form-item>
                            <el-form-item label="透明度:" prop="opacity">
                                <el-input-number :min="0" :max="1" :step="0.1" v-model="ruleForm.opacity"
                                    controls-position="right" @change="opacityChange"></el-input-number>
                            </el-form-item>
                            <el-form-item label="显示精度:" prop="maximumScreenSpaceErrorChange">
                                <el-input-number :min="1" :max="60" :step="1"
                                    v-model="ruleForm.maximumScreenSpaceErrorChange" controls-position="right"
                                    @change="maximumScreenSpaceErrorChange"></el-input-number>
                            </el-form-item>
                            <!-- <el-form-item label="模型亮度:" prop="name">
                                <el-input v-model="ruleForm.name"></el-input>
                            </el-form-item>
                            <el-form-item label="点击高亮:" prop="name">
                                <el-input v-model="ruleForm.name"></el-input>
                            </el-form-item> -->
                        </el-form>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
import TilesetLayer from "@/utils/cesiumBD/layer/TilesetLayer.js";
var tiles3dLayer = null;
export default {
    data() {
        return {
            axisAll: [
                {
                    label: "默认坐标轴",
                    value: "XYZ"
                },
                {
                    label: "X轴转Y轴",
                    value: "X_UP_TO_Y_UP"
                },
                {
                    label: "X轴转Z轴",
                    value: "X_UP_TO_Z_UP"
                },
                {
                    label: "Y轴转X轴",
                    value: "Y_UP_TO_X_UP"
                },
                {
                    label: "Y轴转Z轴",
                    value: "Y_UP_TO_Z_UP"
                }, {
                    label: "Z轴转Y轴",
                    value: "Z_UP_TO_Y_UP"
                },
                {
                    label: "Z轴转X轴",
                    value: "Z_UP_TO_X_UP"
                }
            ],
            ruleForm: {
                url: "http://data.mars3d.cn/3dtiles/max-fsdzm/tileset.json",
                x: "",
                y: "",
                z: "",
                offset_x: 0,
                offset_y: 0,
                offset_z: 0,
                rotationX: 0,
                rotationY: 0,
                rotationZ: 0,
                scale: 1,
                axis: "XYZ",
                opacity: 1,
                maximumScreenSpaceErrorChange: 16
            },
            rules: {},
        };
    },

    mounted() {

    },

    methods: {
        clampToGround() {
            if (!tiles3dLayer) {
                return;
            }
            tiles3dLayer.clampToGround();
        },
        maximumScreenSpaceErrorChange() {
            if (!tiles3dLayer) {
                return;
            }
            var obj = { maximumScreenSpaceErrorChange: this.ruleForm.maximumScreenSpaceErrorChange };
            tiles3dLayer.updateTilesetProp(obj);
        },
        opacityChange() {
            if (!tiles3dLayer) {
                return;
            }
            tiles3dLayer.opacity = this.ruleForm.opacity;
        },
        axisChange() {
            if (!tiles3dLayer) {
                return;
            }
            tiles3dLayer.axis = this.ruleForm.axis;
        },
        scaleChange() {
            if (!tiles3dLayer) {
                return;
            }
            tiles3dLayer.scale = this.ruleForm.scale;
        },
        rotationChange() {
            if (!tiles3dLayer) {
                return;
            }
            tiles3dLayer.rotation_x = this.ruleForm.rotationX;
            tiles3dLayer.rotation_y = this.ruleForm.rotationY;
            tiles3dLayer.rotation_z = this.ruleForm.rotationZ;
        },

        updateOffset() {
            if (!tiles3dLayer) {
                return;
            }
            tiles3dLayer.updateOffset(this.ruleForm.offset_x, this.ruleForm.offset_y, this.ruleForm.offset_z);
        },
        updatePos() {
            if (!tiles3dLayer) {
                return;
            }

            tiles3dLayer.updatePositionXYZ(this.ruleForm.x, this.ruleForm.y, this.ruleForm.z);
        },
        removeLayer() {
            if (tiles3dLayer) {
                tiles3dLayer.remove(true)
                tiles3dLayer = null
            }
        },
        addTilesetLayer() {
            this.removeLayer();
            tiles3dLayer = new TilesetLayer({
                name: "模型名称",
                url: this.ruleForm.url,
                maximumScreenSpaceError: 16,
                maximumMemoryUsage: 1024,
                popup: "all",
                flyTo: true,
            })
            tiles3dLayer.show=true;
            tiles3dLayer.getCenterPromise(res => {
                this.ruleForm.x = res.x;
                this.ruleForm.y = res.y;
                this.ruleForm.z = res.z;
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.edit-room {
    padding: 0 20px;
}
</style>
<style lang="scss">
.list-div-line {
    .el-input {
        width: auto;
    }

}

.list-div-line-m {

    .el-input,
    .el-select,
    .el-input-number {
        width: 160px !important;
    }
}
</style>